/**
 * Messages of the persistence layer (W1-13 persist-workers; namespace 'persist'): labels of the transactions the
 * persist worker journals on its own (History panel entries).
 */

import { catalogOf, defineMessages } from '../i18n/define';

export const m = defineMessages('persist', {
  /** History entry of a Library rename (journaled without opening the project). */
  renameTxn: 'Rename project to "{name}"',
});

export default catalogOf(m);
